import { render, staticRenderFns } from "./CharacterPane.vue?vue&type=template&id=908f57b6&"
import script from "./CharacterPane.vue?vue&type=script&lang=js&"
export * from "./CharacterPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports